<template>
  <div class="section-vote" v-if="showSection">
    <div class="vote-nav">
      <span class="vote-title">{{sectionData.title}}</span>
      <span class="vote-type">{{voteType}}</span>
      <span class="vote-count">{{sectionData.vote_count}}人参与</span>
    </div>
    <div class="vote-container voted-1" 
      v-theme.self="containerColor"
    >
      <div class="vote-item" 
        :class="selected[index] > 0 && 'active'"
        v-for="option,index in sectionData.vote_options"
        :key="index"
      >
        <div class="vote-content">
          <img v-if="option.img" v-hb-img.src="option.img" class="vote-img" alt="" ref="voteimg">
          <div class="vote-text" :class="option.voted == 1 ? 'active': ''">
            {{option.text}}
            <svg class="vote-acitve" v-if="option.voted == 1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_353_28)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1 6L2.25 4.75L4.75 7.25L9.75 2.25L11 3.5L4.75 9.75L1 6Z" fill="#004B96"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66161 2.16161C9.71043 2.1128 9.78957 2.1128 9.83839 2.16161L11.0884 3.41161C11.1372 3.46043 11.1372 3.53957 11.0884 3.58839L4.83839 9.83839C4.78957 9.8872 4.71043 9.8872 4.66161 9.83839L0.911612 6.08839C0.862796 6.03957 0.862796 5.96043 0.911612 5.91161L2.16161 4.66161C2.21043 4.6128 2.28957 4.6128 2.33839 4.66161L4.75 7.07322L9.66161 2.16161ZM9.75 2.42678L4.83839 7.33839C4.78957 7.3872 4.71043 7.3872 4.66161 7.33839L2.25 4.92678L1.17678 6L4.75 9.57322L10.8232 3.5L9.75 2.42678Z" fill="#004B96"/>
              </g>
              <defs>
              <clipPath id="clip0_353_28">
              <rect width="12" height="12" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <p class="vote-btn"><span><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADESURBVHgB7dhhDYMwEIbhkzAJSJiESUHCHEzCJEwKEiahEibhdk12GWmAUZaU78L3JPe3fUMKIRUhIiIiomqqes4jkVjwTb+uEkERnSVBNxGdPQTZTPTT5iSoGN0Ko1tpFm0LXmySzWDTyR+aPulPtEtb47X18bCFX8Vm1fG6x5m2xfuJTVfH654v4tZ4Rfh61MZDRI9iVsVDRY+iFuMho91C/B022s3EY0e7H/Hw/x59uGhXxA8hop3FdhrtSoGIiOgQ3iFhGrltD2GRAAAAAElFTkSuQmCC" alt=""></span></p>
          <p class="vote-ratio">
            <span class="ratio" :class="option.voted != 0 ? 'active': ''" v-if="sectionData.vote_count > 0">{{getRatio(option.vote_count)}}</span>
            <span class="count">{{option.vote_count}}人</span>
          </p>
        </div>
        <div class="progress" :class="option.vote_count > 0 ? 'active' : ''" :style="{width: getRatio(option.vote_count, true)}"></div>
      </div>
    </div>
    <!-- <div class="vote-submit" :class="submitActive" @click="submitVote">
      <p>{{sectionData.voted == 1 ? '已投票' : sectionData.expired == 1 ? '已结束' : '投票'}}</p>
    </div> -->
    <div class="vote-endtime">
      <svg class="vote-svg" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_167_2860)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM6.5 4C6.5 3.72386 6.27614 3.5 6 3.5C5.72386 3.5 5.5 3.72386 5.5 4V6.5C5.5 6.77614 5.72386 7 6 7H8C8.27614 7 8.5 6.77614 8.5 6.5C8.5 6.22386 8.27614 6 8 6H6.5V4Z" fill="#C8CDD2"/>
        </g>
        <defs>
        <clipPath id="clip0_167_2860">
        <rect width="12" height="12" fill="white"/>
        </clipPath>
        </defs>
      </svg>      
      <p>截止时间：{{sectionData.expire_at}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      can_click: true,
      vote_info: null,
      selected: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init () {
      this.vote_info = this.linkInfo.vote_info
      if (!this.sectionData || !this.sectionData.vote_options) return
      for (var i = 0; i < this.sectionData.vote_options.length; i++) {
        this.selected[i] = 0
      }
    },
    getRatio (count, reverse = false) {
      let rate = count / this.sectionData.vote_count * 100
      if (reverse) {
        rate = 100 - rate
      }
      return rate.toFixed(1) + '%'
    },
  },
  computed: {
    showSection () {
      return Boolean(this.vote_info)
    },
    sectionData () {
      return this.vote_info || {}
    },
    voteType () {
      switch (VOTE_TYPE[this.sectionData.vote_type]) {
        case 'single': {
          return `单选`
        }
        case 'multiple': {
          return `多选 ${this.sectionData.vote_choose_limit ? `(最多选${this.sectionData.vote_choose_limit}项)` : ''}`
        }
      }
    },
    containerColor () {
      return {
        light: {background: 'linear-gradient(270deg, #D2DCFC 0.02%, #EAF5FA 99.98%)'},
        dark: {background: 'linear-gradient(270deg, #081339 0%, #102129 100%)'}
      }
    },
    submitActive: function () {
      var flag = this.selected.some(function (item) {
        return item > 0
      })
      if (flag && this.can_click) {
        return 'active'
      }
      return ''
    },
  }
}

const VOTE_TYPE = {
  1: 'single', // 单选
  2: 'multiple' // 多选
}
</script>
<style lang="less">
.section-vote {
  padding: 0 12px;
  margin-bottom: 20px;
  overflow: hidden;
  color: #14191e;
  .vote-nav {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-bottom: 8px;
    .vote-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(20, 25, 30, 1);
    }
    .vote-type, .vote-count {
      margin-left: 6px;
      font-size: 12px;
      line-height: 16px;
      color: rgba(140, 145, 150, 1);
    }
    .vote-count {
      margin-left: auto;
    }
  }
  .vote-container {
    width: 100%;
    overflow: hidden;
    box-shadow: 0, 0, 1px, 1px rgba(0,0,0,0.05);
    border-radius: 8px;
    &.voted-0 {
      background: #FAFBFC;
      .vote-item {
        .vote-btn {
          display: block;
        }
      }
    }
    &.voted-1 {
      // background: #FAFBFC;
      .vote-item {
        .progress {
          display: block;
        }
        .vote-ratio {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
    &:last-of-type {
      .vote-content::after {
        display: none;
      }
    }
    .vote-item {
      width: 100%;
      height: 46px;
      position: relative;
      /* background-color: #FAFBFC; */
      &.active {
        background-color: #F3F4F5;
        .vote-btn {
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #14191E;
            background-color: #14191E;
            img {
              display: inline-block;
            }
          }
        }
      }
      .progress {
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background: #FAFBFC;
        z-index: 1;
        display: none;
        &.active {
          max-width: 98%;
        }
      }
      .vote-content {
        position: relative;
        display: flex;
        padding: 0 10px;
        height: 46px;
        overflow: hidden;
        z-index: 2;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 3%;
          width: 94%;
          height: 1px;
          transform: scaleY(0.5);          
          background-color: rgba(0, 0, 0, 0.04);
        }
      }
      .vote-btn, .vote-ratio {
        flex: 0 0 48px;
        display: none;
        height: 46px;
        line-height: 46px;
      }
      .vote-ratio {
        span {
          width: 100%;
          display: block;
          text-align: right;
          &.ratio {
            font-size: 12px;
            height: 12px;
            line-height: 12px;
            color: #14191E;
            margin-bottom: 2px;
            &.active {
              color: rgba(0, 75, 150, 1);
            }
          }
          &.count {
            font-size: 10px;
            height: 10px;
            line-height: 10px;
            color: #8C9196;
          }
        }
      }
      .vote-img {
        width: 30px;
        height: 30px;
        margin: 8px 10px 8px 0;
      }
      .vote-text {
        flex: 1;
        height: 46px;
        line-height: 46px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #14191e;
        &.active {
          color: rgba(0, 75, 150, 1);
          font-weight: 500;
        }
        .vote-active {
          margin-left: 4px;
        }
      }
      .vote-btn {
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          line-height: 18px;
          border-radius: 50%;
          box-sizing: border-box;
          border: 1px solid #C8CDD2;
          margin: 13px 0 13px 28px;
          display: inline-block;
          text-align: center;
          background-color: #F3F4F5;
          img {
            width: 15px;
            height: 15px;
            display: none;
          }
        }
      }
    }
  }
  .vote-submit {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 10px;
    &.active {
      p {
        background-color: #14191E;
        color: #ffffff;
      }
    }
    p {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #8C9196;
      background-color: #F7F8F9;
      font-size: 15px;
      text-align: center;
    }
  }
  .vote-endtime {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    p {
      height: 12px;
      margin-left: 4px;
      line-height: 12px;
      font-size: 12px;
      color: rgba(140, 145, 150, 1);
      text-align: center;
    }
  }
  @media only screen and (max-width: 640px) {
    .post-vote-wrapper {
      padding: 0 12px;
    }
  }
}
.static-color-level {
  overflow: hidden;
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -ms-transform: scale(0.5);
  transform-origin: left;
  -webkit-transform-origin: left;
  -moz-transform-origin: left;
  -ms-transform-origin: left;
}
/* 账号等级渐变背景 */
.static-color-hb-lv-1, .static-color-hb-lv-2, .static-color-hb-lv-3 {
  background-image: -webkit-linear-gradient(315deg, rgb(232, 232, 232), rgb(208, 208, 208));
  background-image: linear-gradient(135deg, rgb(232, 232, 232), rgb(208, 208, 208))
}
.static-color-hb-lv-4, .static-color-hb-lv-5, .static-color-hb-lv-6 {
  background-image: -webkit-linear-gradient(315deg, rgb(150, 225, 38), rgb(128, 209, 91));
  background-image: linear-gradient(135deg, rgb(150, 225, 38), rgb(128, 209, 91))
}
.static-color-hb-lv-7, .static-color-hb-lv-8, .static-color-hb-lv-9 {
  background-image: -webkit-linear-gradient(315deg, rgb(50, 191, 254), rgb(50, 154, 254));
  background-image: linear-gradient(135deg, rgb(50, 191, 254), rgb(50, 154, 254))
}
.static-color-hb-lv-10, .static-color-hb-lv-11, .static-color-hb-lv-12 {
  background-image: -webkit-linear-gradient(315deg, rgb(247, 70, 254), rgb(214, 70, 254));
  background-image: linear-gradient(135deg, rgb(247, 70, 254), rgb(214, 70, 254))
}
.static-color-hb-lv-13, .static-color-hb-lv-14, .static-color-hb-lv-15 {
  background-image: -webkit-linear-gradient(315deg, rgb(254, 168, 37), rgb(254, 146, 37));
  background-image: linear-gradient(135deg, rgb(254, 168, 37), rgb(254, 146, 37))
}
.static-color-hb-lv-16, .static-color-hb-lv-17, .static-color-hb-lv-18 {
  background-image: -webkit-linear-gradient(315deg, rgb(254, 50, 126), rgb(238, 67, 96));
  background-image: linear-gradient(135deg, rgb(254, 50, 126), rgb(238, 67, 96))
}
.static-color-hb-lv-19, .static-color-hb-lv-20, .static-color-hb-lv-21 {
  background-image: -webkit-linear-gradient(315deg, rgb(50, 55, 60), rgb(20, 25, 30));
  background-image: linear-gradient(135deg, rgb(50, 55, 60), rgb(20, 25, 30))
}
.static-color-hb-lv-22, .static-color-hb-lv-23, .static-color-hb-lv-24, .static-color-hb-lv-25, .static-color-hb-lv-26, .static-color-hb-lv-27 {
  background-repeat: no-repeat;
  background-position: left;
  background-size: auto 100%;
  -webkit-animation: lv22-animate 7s linear infinite;
  -moz-animation: lv22-animate 7s linear infinite;
  -ms-animation: lv22-animate 7s linear infinite;
  animation: lv22-animate 7s linear infinite;
  -webkit-transform: translate3d(0,0,0) scale(0.5);
  -moz-transform: translate3d(0,0,0) scale(0.5);
  -ms-transform: translate3d(0,0,0) scale(0.5);
  transform: translate3d(0,0,0) scale(0.5);
}
.static-color-hb-lv-22, .static-color-hb-lv-23 {
  background-image: url('https://cdn.max-c.com/heybox/dailynews/img/8871d14fe5f364b219e8047e63f0a673.png?uri_type=image');
}
.static-color-hb-lv-24, .static-color-hb-lv-25 {
  background-image: url('https://cdn.max-c.com/heybox/dailynews/img/d49945ff8f3c19055014617a138fa142.png?uri_type=image');
}
.static-color-hb-lv-26, .static-color-hb-lv-27 {
  background-image: url('https://imgheybox.max-c.com/oa/2022/05/27/7d3e467ec7a37cf4e2dad81bdff8c07e.png?uri_type=image');
}
.static-color-hb-lv-28, .static-color-hb-lv-29 {
  position: relative;
}
.loop(50);
.loop(@counter) when (@counter >= 28) {
  .loop((@counter - 1));  
  .static-color-hb-lv-@{counter}{
    position: relative;
  }  
  .static-color-hb-lv-@{counter}::before {
    content: '';
    width: 184px;
    height: 184px;
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    background-repeat: no-repeat;
    background-position: left;
    background-size: 184px 184px;
    background-position: center center;
    background-image: url('https://imgheybox.max-c.com/oa/2023/04/07/82e09812538e029fd3046e56d32a311a.png?uri_type=image');
    -webkit-animation: lv28-animate 6s linear infinite;
    -moz-animation: lv28-animate 5s linear infinite;
    -ms-animation: lv28-animate 5s linear infinite;
    animation: lv28-animate 5s linear infinite;
    -webkit-transform-origin: center;
    -moz-transform-origin: center;
    -ms-transform-origin: center;
    transform-origin: center;
    z-index: 0;
  }
}


@-webkit-keyframes lv28-animate {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(1turn);
  }
}
@-moz-keyframes lv28-animate {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(1turn);
  }
}
@-ms-keyframes lv28-animate {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(1turn);
  }
}
@keyframes lv28-animate {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(1turn);
  }
}

@-webkit-keyframes lv22-animate {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
@-moz-keyframes lv22-animate {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
@-ms-keyframes lv22-animate {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
@keyframes lv22-animate {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
</style>